import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxSpinnerModule } from 'ngx-spinner'
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { NumberDirective } from '../shared/numbersonly.directive';
import { WelcomeComponent } from './welcome/welcome.component';
import { ShopkeeperComponent } from './shopkeeper/shopkeeper.component';
import { CreateshopComponent } from './createshop/createshop.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ConfirmEqualValidatorDirective } from '../shared/confirm-equal-validator.directive';
import { SocketclientService } from './socketclient.service';
import { LoginComponent } from './login/login.component';
import { CustomerComponent } from './customer/customer.component';
import { AgmCoreModule } from '@agm/core';
import { ChangepincodeComponent } from './changepincode/changepincode.component';
import { BookinghistoryComponent } from './bookinghistory/bookinghistory.component';
import { SuggestionComponent } from './suggestion/suggestion.component';
import { CustomertokenComponent } from './customertoken/customertoken.component';
import { EntityloginComponent } from './entitylogin/entitylogin.component';
import { ChatService } from './chat.service';
import { ChatcomponentComponent } from './chatcomponent/chatcomponent.component';
import { ChatuserlistComponent } from './chatuserlist/chatuserlist.component';
import { StaffloginComponent } from './stafflogin/stafflogin.component';


@NgModule({
  declarations: [
    AppComponent,
    NumberDirective,
    WelcomeComponent,
    ShopkeeperComponent,
    CreateshopComponent,
    ConfirmEqualValidatorDirective,
    LoginComponent,
    CustomerComponent,
    ChangepincodeComponent,
    BookinghistoryComponent,
    SuggestionComponent,
    CustomertokenComponent,
    EntityloginComponent,
    ChatcomponentComponent,
    ChatuserlistComponent,
    StaffloginComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    NgxSpinnerModule,
    NgxMaterialTimepickerModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBlUl5nFhq71cT8RYqn0W3ADQ3ZtJfz02s'
    })
  ],
  providers: [
    // { provide: LocationStrategy, useClass: HashLocationStrategy },
    CookieService,
    SocketclientService,
    ChatService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
